// extracted by mini-css-extract-plugin
module.exports = {"animate":"Receipt_animate__kIP4F","background":"Receipt_background__vKQuD"};